

export const getDomains = ({ state }) => state.domains



// WEBPACK FOOTER //
// ./src/app/company/vuex/getters.js